import Icon from '@/components/icon';
import { IconType } from '@/components/icon/helpers';
import Text from '@/components/text';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  icon: IconType;
  label: string;
  onClick: () => void;
}

const useStyles = createUseStyles({
  toolbarButton: {
    '& .MuiTypography-root': {
      marginTop: 1,
    },
  },
});

const ToolbarButton: FC<Props> = ({ onClick, label, icon }) => {
  const styles = useStyles();
  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      width="100%"
      gap={1}
      role="button"
      onClick={onClick}
      className={styles.toolbarButton}
    >
      <Icon name={icon} size="small" />
      <Text size="x-small">{label}</Text>
    </Stack>
  );
};

export default ToolbarButton;
